import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { TmsWebBaseService } from '../base';
import { Order } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class ShopifyService extends TmsWebBaseService {
  constructor() {
    super('Shopify');
  }

  importSalesOrders(
    search: string,
    allStock: boolean,
    needAttention: boolean,
    importOrders: boolean,
  ): Observable<Order[]> {
    return this.httpService.post<Order[]>(`${this.apiUrl}/ImportSalesOrders`, {
      search,
      allStock,
      needAttention,
      importOrders,
    });
  }
}
